import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=014a05c6&scoped=true&lang=pug&"
import script from "./Navbar.vue?vue&type=script&lang=js&"
export * from "./Navbar.vue?vue&type=script&lang=js&"
import style0 from "./Navbar.vue?vue&type=style&index=0&id=014a05c6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014a05c6",
  null
  
)

/* custom blocks */
import block0 from "@/lang/components/navbar.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fsrc%2Fcomponents%2FNavbar.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports